"use client";
import Flex from "@/components/core/flex";
import BreadCrumbList from "@/components/shared/breadCrumbList";
import Text from "@/components/shared/text";
import useLocalizer from "@/hooks/useLocalizer";
import { Link } from "@/i18n/routing";
import { cn, getFilePath } from "@/lib/utils/utils";
import { ClientServicesSection } from "@/types/service";
import Image from "next/image";
interface Props {
  data: ClientServicesSection;
  className?: string;
}
const ServicesContent = ({ data, className }: Props) => {
  const clientServices = data;
  const { t, isRtl } = useLocalizer();
  return (
    <section className={cn("relative", className)}>
      <div className="relative h-80">
        <div
          className="w-full h-full absolute -top-10 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: clientServices.banner
              ? `url('${getFilePath(clientServices.banner?.key)}')`
              : undefined,
          }}
        >
          <div className="w-full h-full bg-black/50 flex justify-center items-center z-20 flex-col">
            <BreadCrumbList
              items={[
                {
                  name: t("pages.home"),
                  href: "/",
                },
                {
                  name: t("pages.services"),
                },
              ]}
            />
            <Text as="h4" className="font-bold text-white">
              {isRtl ? clientServices?.arTitle : clientServices?.enTitle}
            </Text>
          </div>
        </div>
      </div>
      <div className="w-full h-full mb-20 mt-10 px-5 lg:px-0 ">
        <div className="container mx-auto w-full h-full">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 w-full gap-6">
            {clientServices?.services?.map((service, index) => (
              <div
                key={index}
                className="w-full h-[520px] border-b border-r border-l border-primary/20 bg-white flex flex-col justify-between z-20 overflow-hidden transition-all duration-300 ease-in-out"
              >
                <div className="relative overflow-hidden  h-[400px] w-full transition-all duration-300 ease-in-out hover:[&_.ser-top-cover]:h-full hover:[&_.ser-bottom-cover]:h-full hover:[&_.ser-small-img-frame]:p-0 ">
                  <div className="absolute  w-full h-0 bg-black/20 -top-2/4 left-0 right-0 ser-top-cover z-20 transition-all duration-500 ease-linear" />
                  <div className="absolute  w-full h-0 bg-black/20 -bottom-2/4 left-0 right-0 ser-bottom-cover z-20 transition-all duration-500 ease-linear" />
                  <Image
                    src={getFilePath(service.image?.key ?? "")}
                    alt={
                      isRtl
                        ? (service?.arTitle ?? "")
                        : (service?.enTitle ?? "")
                    }
                    fill
                    priority
                    placeholder="empty"
                    className="object-cover"
                  />
                  <div className="absolute bg-secondary h-[106px] w-[106px] bottom-5 left-5 p-3 opacity-90 z-30 transition-all duration-500 ease-linear ser-small-img-frame">
                    <div className="relative h-full w-full">
                      <Image
                        src={getFilePath(service.image?.key ?? "")}
                        alt={
                          isRtl
                            ? (service?.arTitle ?? "")
                            : (service?.enTitle ?? "")
                        }
                        fill
                        priority
                        placeholder="empty"
                        className="object-cover ser-small-img"
                      />
                    </div>
                  </div>
                </div>
                <Flex className="flex-1">
                  <Flex
                    direction="col"
                    spacing={{ all: 2 }}
                    className="px-4 lg:px-8 py-2 lg:py-6"
                  >
                    <Link
                      href={`services/${service?.id}`}
                      aria-label={
                        isRtl
                          ? (service?.arTitle ?? "")
                          : (service?.enTitle ?? "")
                      }
                    >
                      <Text
                        as="h5"
                        className="text-secondary font-bold line-clamp-1 lg:line-clamp-2 hover:text-primary "
                      >
                        {isRtl ? service?.arTitle : service?.enTitle}
                      </Text>
                    </Link>
                    <Text className="text-secondary-foreground lg:line-clamp-3 line-clamp-2 text-sm lg:text-lg">
                      {isRtl ? service?.arDescription : service?.enDescription}
                    </Text>
                  </Flex>
                </Flex>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesContent;
